import React, { useState } from "react";

import { getIcon } from "../../../../helpers/icons";
import DialogBox from "../../../../components/DialogBox";
import CancelMembershipDialogBox from "../../../../components/DialogBox/CancelMembership";

import style from "../style.module.css";

export default function CancelMembership() {
    const [popup, setPopup] = useState(false);

    return (
        <>
            <div className={style.changePlan}>
                <div className={style.bigBtn} onClick={() => setPopup("cancel_membership")}>
                    Cancel membership <span><i className={getIcon("Chevronright")}></i></span>
                </div>
            </div>
            {
                popup === "cancel_membership" && (
                    <DialogBox
                        onClose={() => setPopup(false)}
                        className={`${style.articlePopup}`}
                        title={false}
                        headerClass={style.dialogBoxHeader}
                        modalClassName={style.articleModal}
                        buttonClassName={style.customCloseStyle}
                        hasCloseIcon={false}
                        render={({ closeDialog }) => (
                            <CancelMembershipDialogBox closeDialog={closeDialog} />
                        )}
                    />
                )
            }
        </>
    );
}